<footer class="{{footerClass}}">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <a routerLink="/" class="logo">
                        <img src="https://imgvid.blob.core.windows.net/imgvid/logo.png" alt="logo">
                    </a>
                    <p>Zero-code computer vision intelligence solution. See what it can do for you. Contact us today!</p>
                    <ul class="social-link">
                    </ul>
                </div>
            </div>

            <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="single-footer-widget pl-5">
                </div>
            </div>

            <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Address</h3>
                    <ul class="footer-contact-info">
                        <li><i class='bx bx-map'></i>146 Main St, Los Altos, CA 94022</li>
                        <li><i class='bx bx-phone-call'></i><a href="tel:+16505647454">+1 (650) 564-7454‬</a></li>
                        <li><i class='bx bx-envelope'></i><a href="mailto:hello@awareye.com">hello@awareye.com</a></li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="footer-bottom-area">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6">
                    <p><i class='bx bx-copyright'></i>2024-{{ currentYear }} Awareye Inc. All Rights Reserved.</p>
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="footer-map"><img src="https://imgvid.blob.core.windows.net/imgvid/footer-map.png" alt="image"></div> -->
</footer>

<div class="go-top"><i class="flaticon-up"></i></div>